export const getPagesComponent =
    (component: keyof typeof import('./pages.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "pages" */
            './pages.chunk'
        );
        return chunk[component];
    };
